export default {

	init() {
		console.log('init video...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
		document.addEventListener("DOMContentLoaded", this.lazyLoadVideos);
		document.addEventListener("DOMContentLoaded", this.sizeWistiaIframe);
		$(window).on('resize', this.sizeWistiaIframe);
	},

	bindEvents() {
		var elems = document.querySelectorAll('button[data-video-toggle]');

		if (!elems.length) {
			return;
		}

		elems.forEach(function (elem) {

			elem.addEventListener('click', function(e) {
				let videoElem = elem.previousElementSibling;
				let videoState = elem.getAttribute('data-video-toggle');

				if(videoElem && videoElem.nodeName.toLowerCase() === 'video') {
					if (videoState === 'play') {
						videoElem.play();
						elem.setAttribute('data-video-toggle', 'pause');
					} else {
						videoElem.pause();
						elem.setAttribute('data-video-toggle', 'play');
					}
				}
			});

		});
	},

	lazyLoadVideos() {
		var elems = document.querySelectorAll('video.needs-loaded');

		if (!elems.length) {
			return;
		}

		elems.forEach(function (elem) {

			elem.src = elem.getAttribute('video-src');
			elem.load();
			elem.play();

			// elem.addEventListener('click', function(e) {
			// 	let videoElem = elem.previousElementSibling;
			// 	let videoState = elem.getAttribute('data-video-toggle');

			// 	if(videoElem && videoElem.nodeName.toLowerCase() === 'video') {
			// 		if (videoState === 'play') {
			// 			videoElem.play();
			// 			elem.setAttribute('data-video-toggle', 'pause');
			// 		} else {
			// 			videoElem.pause();
			// 			elem.setAttribute('data-video-toggle', 'play');
			// 		}
			// 	}
			// });

		});
	},

	sizeWistiaIframe() {
		$('.wistia-video-wrapper > iframe').each(function(){
			const wrapper = $(this).closest('.wistia-video-wrapper');
			const iframe = $(this);

			let aspectRatio;
			if(wrapper.attr('iframe-aspect-ratio') !== undefined) {
				aspectRatio = parseFloat(wrapper.attr('iframe-aspect-ratio'));
			} else {
				let { width, height } = $(this)[0].getBoundingClientRect();
				console.log(width, height);
				aspectRatio = height / width;
				wrapper.attr('iframe-aspect-ratio', aspectRatio);

				$(this).css('width', '100%');
			}

			iframe.css('min-width', '0px');

			//Write CSS
			const newWidthHeight = iframe[0].getBoundingClientRect();
			let newHeight = Math.ceil(aspectRatio * newWidthHeight.width);

			const wrapperRect = wrapper[0].getBoundingClientRect();

			if(wrapperRect.height > newHeight && wrapper.hasClass('cover')) {
				newHeight = wrapperRect.height;
				const newWidth = Math.ceil(newHeight / aspectRatio);
				iframe.css('min-width', newWidth + 'px');
			}
			iframe.css('height', newHeight + 'px');
		})
	}

};